module.exports = __webpack_public_path__ + "img/progress_010.e8de087d.png";